<template>
  <div class="carParams-page">
    <div class="par-con" v-for="(list, title) in showParams" :key="'t' + title">
      <div class="par-title">{{title}}</div>
      <div class="par-list">
        <div class="par-row" v-for="(item, indexI) in showParams[title]" :key="'i' + title + '-' + indexI">
          <div class="par-field">{{item.title}}</div>
          <div class="par-value">{{item.value || "-"}}</div>
        </div>  
      </div>
    </div>
    <div class="remark">
      <div class="iconfont uc-zhuyi"></div>
      <div class="text">基本信息为初评时录入，实际参数以看车时为准！</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const StandardParams = require('../configs/carStandardInfo.json')
const level2FilterProps = (obj, props = []) => {
  let newObj = {}
  Object.keys(obj).forEach(item => {
    newObj[item] = obj[item].filter(ls => !props.includes(ls.key))
  })
  return newObj
}
const showParams = level2FilterProps(StandardParams, ["trip", "regDate", "transferCnt"])

export default {
  components: {},
  props: {},
  data() {
    return {
      showParams
    };
  },
  watch: {
    pageInfo(newInfo){
      const { Extinfo }  = newInfo
      if(Extinfo){
        Object.keys(this.showParams).forEach(key => {
          let list = this.showParams[key] || []
          list.forEach(item => {
              if(item.type === "select" || item.type === "radio"){
                const _index = Extinfo[item.key]
                item.value = item.options[_index]
              }else if(item.key === 'newCarPrice'){
                item.value = (Extinfo[item.key] / 100 /10000).toFixed(2) + '万'
              }else{
                item.value = Extinfo[item.key]
              }
          })
        })
      }
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo"
    ])
  },
  methods: {

  },
  beforeCreate() {},
  created() {},
  mounted() {
    console.log('this.showParams:',this.showParams)
    console.log('this.pageInfo:',this.pageInfo)
  }
};
</script>
<style lang="scss" scoped>
.carParams-page{
    width: 100%;
    overflow: hidden;
    .par-con{
        margin: 0.30407459963511047rem;
        padding: 0.20271639975674033rem;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
        .par-title{
            color:#333;
            font-size: 0.2635313196837624rem;
            padding: 0.10135819987837016rem 0px;
            font-weight: bold;
        }
        .par-list{
            display: flex;
            flex-direction: column;
            .par-row{
                display: flex;
                justify-content: space-between;
                font-size: 0.2635313196837624rem;
                border-bottom: solid 1px #f4f4f4;
                padding: 0.15203729981755523rem 0px;
                .par-field{
                    color:#666;
                }
                .par-value{
                    color:#999;
                }
                &:last-child{
                    border-bottom: none;
                }
            }
        }
    }
    .remark{
        padding: 0px 0.30407459963511047rem 0.30407459963511047rem 0.30407459963511047rem;
        display: flex;
        font-size: 0.22298803973241435rem;
        color:#666;
        align-items: center;
        .uc-zhuyi{
            font-size: 0.28380295965943647rem;
            color:#666;
        }
        .text{
            margin-left: 0.10135819987837016rem;
        }
    }
}
</style>